import * as Haptics from 'expo-haptics'
import { Platform } from 'react-native'

export const impactAsync = Platform.select({
  web: async (style = Haptics.ImpactFeedbackStyle.Medium) => {
    if ('vibrate' in navigator) {
      const durationMap = {
        [Haptics.ImpactFeedbackStyle.Light]: 50,
        [Haptics.ImpactFeedbackStyle.Medium]: 100,
        [Haptics.ImpactFeedbackStyle.Heavy]: 200,
      }
      navigator.vibrate(durationMap[style] || 100)
    }
  },
  default: Haptics.impactAsync, // native platforms
})
